"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnyAncestorBindingConstraintsWithTag = isAnyAncestorBindingConstraintsWithTag;
const isAnyAncestorBindingConstraints_1 = require("./isAnyAncestorBindingConstraints");
const isBindingConstraintsWithTag_1 = require("./isBindingConstraintsWithTag");
function isAnyAncestorBindingConstraintsWithTag(tag, value) {
    return (0, isAnyAncestorBindingConstraints_1.isAnyAncestorBindingConstraints)((0, isBindingConstraintsWithTag_1.isBindingConstraintsWithTag)(tag, value));
}
//# sourceMappingURL=isAnyAncestorBindingConstraintsWithTag.js.map